<template>
  <div class="banner" :class="className">
    <h1 class="banner-title" v-html="title"></h1>
    <div class="banner-desc" v-html="desc"></div>
  </div>
</template>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 500px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 500px;
  //   background-image: url("../../assets/imgs/banner_erp.png");
  overflow: hidden;
  .banner-title {
    font-size: 58px;
    font-weight: bold;
    line-height: 81px;
    color: #fff;
    margin: 220px auto 0;
    text-align: center;
  }
  .banner-desc {
    font-size: 24px;
    font-weight: 300;
    color: #fff;
    line-height: 32px;
    margin-top: 14px;
    text-align: center;
    white-space: pre-wrap;
  }
}
</style>
<script>
export default {
  props: {
    className: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  }
};
</script>